export const getFullUrl = (path = '', subdomain) => {
  const protocol = window.location.protocol;
  let host = window.location.host || '';
  const wwwIndex = host.indexOf('www.');

  if (subdomain && wwwIndex !== -1) {
    host = `${subdomain}.${host.substring(wwwIndex + 4)}`;
  } else if (subdomain) {
    host = `${subdomain}.${host}`;
  }

  return `${protocol}//${host}${path}`;
};

export const appendQueryString = (url, queryString) => {
  if (!queryString) return url;
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${queryString}`;
};

const BRAND_NAMES = {
  shipsticks: 'ShipSticks',
  shipplay: 'Ship&Play',
  shipcamps: 'ShipCamps',
  shipskis: 'ShipSkis',
  shipgo: 'ShipGo'
};

export const brandName = (brandId) => {
  if (!brandId) return 'ShipSticks';
  return BRAND_NAMES[brandId.toLowerCase()] || 'ShipSticks';
};

export const formatBrandName = (brand) => {
  if (typeof brand !== 'string') return '';
  return brand.replace(/\s+/g, '');
};

export const supportHostnameFor = (brand) => {
  const b = formatBrandName(brand).toLocaleLowerCase();
  return `${b}.com`;
};

export const formatLocation = function(location) {
    if (location) {
      if(location.formattedAddress) {
        return location.formattedAddress
      } else {
        return location.formatted_address
      }
    }
  }
